module.exports = __webpack_public_path__ + "static/high_performer_mid-bd42c40102672b2f651cc648cc01cef4.svg";